// The attachment row's remove/delete trash icon (Figma "Icon_RemoveAttachment") — a line icon,
// replacing the filled trash ExternalAttachment used to default to.
export default function RemoveAttachmentIcon({ width = 14, height = 14, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
        <path d='M6.31824 3.40909V0.5H10.6819V3.40909' />
        <path d='M0.5 4.40906H16.5' />
        <path d='M14.3181 5.40906L13.7349 13.5647C13.6534 14.7065 12.7036 15.5909 11.5589 15.5909H5.43667C4.29194 15.5909 3.34213 14.7051 3.26067 13.5632L2.68176 5.40906' />
      </g>
    </svg>
  );
}
